import { useState } from "react"
import { useAsync, useAsyncCallback } from "react-async-hook"
import { useNavigate, useParams } from "react-router-dom"
import { useApp } from "../../AppProvider"
import { useApi } from "../../hooks/useApi"
import { Button } from "../common"

const initialData = {
  name: "",
  active: true,
  users: [],
}

export const EditOrganization = () => {
  const { organizationId } = useParams()
  const [formData, setFormData] = useState<any>(initialData)
  const [error, setError] = useState("")
  const { createOrganization, updateOrganization, getOrganization } = useApi()
  const { addToast } = useApp()
  const navigate = useNavigate()

  const organizationAsync = useAsync(async () => {
    if (organizationId === "new" || !organizationId) return
    const organization = await getOrganization(organizationId)
    setFormData({
      name: organization.name,
      active: organization.active,
    })
    return organization
  }, [organizationId])

  const onSubmitAsync = useAsyncCallback(async () => {
    const payload: any = { ...formData }

    if (organizationAsync.result) {
      await updateOrganization(organizationAsync.result._id, payload)
      addToast("Success", "Organization data saved", "success")
    } else {
      await createOrganization(payload)
      addToast("Success", "Organization created", "success")
    }

    // Cleanup
    setFormData({ name: "" })
    navigate(`/private/organizations`)
  })

  const onSubmit = (e: any) => {
    e.preventDefault()
    if (onSubmitAsync.loading) return

    if (!formData.name) {
      return setError("Name is required")
    }
    setError("")

    onSubmitAsync.execute()
  }

  return (
    <div className="card">
      <div className="text-lg font-semibold text-gray-900">
        {organizationId === "new" ? "Create" : "Edit"} organization
      </div>

      <form onSubmit={onSubmit} className="mt-3 space-y-3">
        <div>
          <label className="label" htmlFor="name">
            Name
          </label>
          <input
            name="name"
            type="text"
            placeholder="Pet analytics corp"
            className="input"
            required
            value={formData.name}
            onChange={(e) => setFormData({ ...formData, name: e.currentTarget.value })}
          />
        </div>

        {organizationId !== "new" && (
          <div>
            <label htmlFor="active" className="label">
              Active
            </label>
            <input
              className="checkbox"
              type="checkbox"
              name="active"
              checked={formData.active}
              onChange={(e) => setFormData({ ...formData, active: e.currentTarget.checked })}
            />
          </div>
        )}

        {error && <div className="error-message">{error}</div>}

        <div className="mt-4 flex items-center justify-end gap-x-2">
          <Button variant="secondary" type="button" onClick={() => navigate(-1)}>
            Cancel
          </Button>
          <Button type="submit">Save</Button>
        </div>
      </form>
    </div>
  )
}
